import type { Listing } from '@thevillages/schemas';

export function ComputedListingOpenNow(listing: Listing): boolean {
  if (!listing.openToday?.end) {
    return false;
  }

  return listing.openToday.end > new Date();
}
